import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiListDataService} from './api.list-data.service';
import {PackageServiceModel} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ApiPackageServiceService extends ApiListDataService<PackageServiceModel, PackageServiceModel> {

  constructor(http: HttpClient) {
    super(http, '/PackageService/');
  }
}
